<template>
  <div>
    <div id="RightNav">
      <ul>
        <li>
          <router-link to="/Declare">
            <div>申报</div>
            <div>说明</div>
          </router-link>
        </li>
        <li>
          <!-- <router-link to="/Chart"> -->

          <div>申报</div>
          <div>流程</div>
          <!-- </router-link> -->
        </li>
        <!-- <li>
          <div>疑问</div>
          <div>解答</div>
        </li>-->
        <li @click="goBenefit">
          <div>效益</div>
          <div>计算</div>
        </li>
        <li>
          <div>Q Q</div>
          <div>客服</div>
        </li>
        <li @click="backTop">
          <div>返回</div>
          <div>顶部</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  updated() {
    this.move();
  },
  methods: {
    goBenefit() {
      let routeUrl = this.$router.resolve({
        path: "/Benefit"
        // query: { id: id }
      });
      window.open(routeUrl.href, "_blank");
    },
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 20);
    },

    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 60) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    move() { }
  }
};
</script>

<style lang="less" scoped>
#RightNav {
  font-size: 0.14rem;
  position: relative;
  color: #fff;
  z-index: 999;

  ul {
    position: fixed;
    top: 3.27rem;
    right: 0.43rem;

    li {
      width: 0.47rem;
      height: 0.67rem;
      // //    padding: 0.rem 0.1rem  0 0.1rem;
      // // padding: 0.17rem 0.1rem 0 0.08rem;
      // // padding: .17rem 0 0.1rem 0rem;
      background-image: url("../assets/RightNav/2.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin-top: -0.08rem;
      text-align: center;
      padding-top: 0.16rem;
      cursor: pointer;

      a {
        color: #fff;
        padding-bottom: 0.12rem;
      }
    }

    li:nth-of-type(1) {
      width: 0.47rem;
      padding-top: 0.08rem;
      height: 0.6rem;
      background-image: url("../assets/RightNav/1.png");
    }

    li:nth-of-type(5) {
      width: 0.47rem;
      height: 0.63rem;
      padding-bottom: 0.15rem;
      background-image: url("../assets/RightNav/3.png");

      // padding: 0.18rem 0.05rem 0rem 0.1rem;
    }
  }

  .advertising {
    width: 4.52rem;
    height: 2.71rem;
    position: absolute;
    top: 3rem;
    right: 2rem;
    z-index: 99;

    img {
      width: 100%;
    }
  }
}</style>